import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Weather.css";

let apiKey = process.env.REACT_APP_DICTIONARY_KEY;

export default function Weather() {
  let [weather, setWeather] = useState(null);
  let [inputValue, setInputValue] = useState("");

  function handleResponse(response) {
    setWeather(response.data);
  }

  function search(cityName) {
    let url = `https://api.shecodes.io/weather/v1/current?query=${cityName}&key=${apiKey}&units=metric`;
    axios.get(url).then(handleResponse);
  }

  useEffect(() => {
    search("Rome");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleSubmit(event) {
    event.preventDefault();
    if (inputValue.trim()) {
      search(inputValue);
    }
  }

  function updateInput(event) {
    setInputValue(event.target.value);
  }

  return (
    <div className="Weather">
      <form className="Weather-form" onSubmit={handleSubmit}>
        <input
          type="search"
          placeholder="Città"
          className="Weather-input"
          onChange={updateInput}
        />
        <button type="submit" className="Weather-button" aria-label="Cerca città">
          🔍
        </button>
      </form>

      {weather && (
        <div className="Weather-info">
          <p className="Weather-city">{weather.city}</p>
          <div className="Weather-main">
            <img
              src={weather.condition.icon_url}
              alt={weather.condition.description}
              className="Weather-icon"
            />
            <span className="Weather-temperature">
              {Math.round(weather.temperature.current)}°C
            </span>
          </div>
          <p className="Weather-description">{weather.condition.description}</p>
          <p className="Weather-details">
            Umidità: {weather.temperature.humidity}% · Vento:{" "}
            {Math.round(weather.wind.speed)} km/h
          </p>
        </div>
      )}
    </div>
  );
}
